import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OtpDialogDataModel} from '../../../../constants/models/otp-dialog-data-model';

@Component({
  selector: 'app-otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrls: ['./otp-modal.component.scss']
})
export class OtpModalComponent implements OnInit, AfterViewInit {

  otpField!: FormControl;
  @ViewChild('otpInput') otpInput!: MatInput;
  countDownTimer!: any;
  secondsRemaining!: number;

  constructor(
    public dialogRef: MatDialogRef<OtpModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: OtpDialogDataModel
  ) { }

  ngOnInit(): void {
    this.otpField = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
    this.secondsRemaining = this.dialogData.timerSeconds;
  }

  get otp() {
    return this.otpField.value;
  }

  ngAfterViewInit(): void {
    this.initCountDown();
  }

  closeDialog(isSubmit: boolean) {
    if (!isSubmit) {
      this.dialogRef.close({
        event: 'edit'
      });
    } else {
      this.dialogRef.close({
        event: 'submit',
        otp: this.otp
      });
    }
  }

  initCountDown() {
    this.secondsRemaining = this.dialogData.timerSeconds;
    this.otpField.reset();
    this.countDownTimer = setInterval(() => {
      if (this.secondsRemaining > 0) {
        this.secondsRemaining--;
      } else {
        this.clearCountdown();
      }
    }, 1000);
  }

  clearCountdown() {
    clearInterval(this.countDownTimer);
  }

  resendOtp() {
    if (this.dialogData.enableResendOtp) {
      this.initCountDown();
      this.dialogData.onResendOtp();
    }
  }

}
